import { createClient } from '@supabase/supabase-js';
import { env } from './environment';

// Safely access environment variables with fallbacks
const supabaseUrl = env.supabaseUrl;
const supabaseAnonKey = env.supabaseAnonKey;

// Check if we have the required environment variables
if (!supabaseUrl || !supabaseAnonKey) {
  console.warn('Supabase environment variables are not set. OAuth features will be disabled.');
}

// Create Supabase client
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: false, // We handle OAuth callback manually in use-auth hook
    flowType: 'pkce', // Use PKCE flow for better security and provider token support
  },
});

// Helper function to get the redirect URL
const getRedirectUrl = () => {
  const baseUrl = window.location.origin;
  return `${baseUrl}/dashboard`;
};

// OAuth login functions
export const loginGoogle = async () => {
  if (!supabaseUrl || !supabaseAnonKey) {
    throw new Error('Supabase is not configured. Please set VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY.');
  }
  
  const { data, error } = await supabase.auth.signInWithOAuth({
    provider: 'google',
    options: {
      redirectTo: getRedirectUrl(),
      scopes: 'email openid profile https://www.googleapis.com/auth/gmail.readonly https://www.googleapis.com/auth/gmail.send',
      queryParams: {
        access_type: 'offline',
        prompt: 'consent'
      }
    },
  });
  
  if (error) throw error;
  return data;
};

export const loginMicrosoft = async () => {
  if (!supabaseUrl || !supabaseAnonKey) {
    throw new Error('Supabase is not configured. Please set VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY.');
  }
  
  const { data, error } = await supabase.auth.signInWithOAuth({
    provider: 'azure',
    options: {
      redirectTo: getRedirectUrl(),
      scopes: 'email openid profile offline_access https://graph.microsoft.com/Mail.Read https://graph.microsoft.com/Mail.Send',
      queryParams: {
        prompt: 'consent'
      }
    },
  });
  
  if (error) throw error;
  return data;
};

// Helper to get current Supabase session
export const getSupabaseSession = async () => {
  const { data: { session }, error } = await supabase.auth.getSession();
  if (error) throw error;
  return session;
};

// Helper to sign out from Supabase
export const signOutSupabase = async () => {
  const { error } = await supabase.auth.signOut();
  if (error) throw error;
}; 